export default {
	borders: {
		veryEasy: 80,
		easy: 70,
		fairlyEasy: 60,
		okay: 50,
		fairlyDifficult: 40,
		difficult: 20,
		veryDifficult: 0,
	},
	scores: {
		veryEasy: 9,
		easy: 9,
		fairlyEasy: 9,
		okay: 9,
		fairlyDifficult: 6,
		difficult: 3,
		veryDifficult: 3,
	},
};
